import ContentsTypes from "@shared/enums/contentsTypes";
import PackCyberTemplate from "@project/templates/pack-cyber/PackCyberTemplate";
import customTypes from "@project/enums/contentsCustomTypes.enum";
import { createRowButtonItem } from "@project/templates/home/home";
import { createPricingCardItem } from "@project/templates/pricingCardItem";
import { createButton } from "@project/templates/buttonWithArrow";
import { createIllustrationTabs } from "@project/templates/illustrationTabItem";
import { createStepsItem } from "@project/templates/stepsItem";
export default {
    key: "PACK_CYBER",
    label: "Pack Cyber",
    shortDescription: "Il réunit les protections essentielles pour renforcer la sécurité de votre organisation, protéger vos données et simplifier le pilotage de votre cybersécurité.",
    templateImage: "/template-pack-cyber.png",
    Component: PackCyberTemplate,
    initialContents: [
        {
            key: "title",
            type: ContentsTypes.TEXT,
            value: "%3Ch1%3E%3Cspan%20style%3D%22color%3Ahsl(0%2C%200%25%2C%20100%25)%3B%22%3EAvec%20le%20%3Cstrong%3EPack%20Cyber%3C%2Fstrong%3E%2C%20s%C3%A9curisez%20l%E2%80%99essentiel%20de%20votre%20environnement%20num%C3%A9rique%3C%2Fspan%3E%3C%2Fh1%3E",
        },
        {
            key: "shortDescription",
            type: ContentsTypes.TEXT,
            value: "%3Cp%20style%3D%22line-height%3A1.6%3B%22%3E%3Cspan%20style%3D%22color%3Ahsl(0%2C%200%25%2C%20100%25)%3Bfont-size%3A16px%3B%22%3EIl%20r%C3%A9unit%20les%20protections%20essentielles%20pour%20renforcer%20la%20s%C3%A9curit%C3%A9%20de%20votre%20organisation%2C%20prot%C3%A9ger%20vos%20donn%C3%A9es%20et%20simplifier%20le%20pilotage%20de%20votre%20cybers%C3%A9curit%C3%A9.%3C%2Fspan%3E%3C%2Fp%3E",
        },
        {
            key: "presentationDynamic",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: [
                {
                    key: "dynamicElements",
                    type: "ROW",
                    value: "",
                    children: [
                        createRowButtonItem("Demander à être accompagné", "contained"),
                        createRowButtonItem("Voir les protections incluses", "outlined"),
                        {
                            key: "justifyContent",
                            type: ContentsTypes.SELECT,
                            value: "flex-start",
                        },
                        { key: "spacing", type: "SLIDER", value: "24" },
                        { key: "columnOnMobile", type: "CHECKBOX", value: "true" },
                        { key: "useFlexWrap", type: "CHECKBOX", value: "true" },
                        {
                            key: "spacingMobile",
                            type: "SLIDER",
                            value: "16",
                        },
                    ],
                },
            ],
        },
        {
            key: "offerPresentationCard",
            type: customTypes.OFFER_PRESENTATION_CARD,
            value: "",
            children: [
                {
                    key: "barColor",
                    type: ContentsTypes.COLOR,
                    value: "#0CFFC6",
                },
                {
                    key: "surtitle",
                    type: ContentsTypes.INPUT,
                    value: "Le Pack cyber",
                },
                {
                    key: "isPriceCard",
                    type: ContentsTypes.CHECKBOX,
                    value: "true",
                },
                { key: "title", type: ContentsTypes.INPUT, value: "15,99 €" },
                {
                    key: "titleComplement",
                    type: ContentsTypes.INPUT,
                    value: "HT / poste / mois",
                },
                {
                    key: "titleFeatures",
                    type: ContentsTypes.INPUT,
                    value: "Inclus dans le pack",
                },
                {
                    key: "features",
                    type: ContentsTypes.TEXT,
                    value: "<ul><li>Postes de travail & serveurs supervisés</li><li>Patrimoine de données sécurisé</li><li>Accès aux mots de passe centralisé</li></ul>",
                },
                {
                    key: "plusFeature",
                    type: ContentsTypes.INPUT,
                    value: "Acces a mon espace client cyber",
                },
                {
                    key: "plusFeatureIcon",
                    type: ContentsTypes.ICON,
                    value: "",
                    children: [
                        { key: "icon", type: ContentsTypes.INPUT, value: "desktop" },
                        { key: "type", type: ContentsTypes.SELECT, value: "far" },
                        { key: "color", type: ContentsTypes.COLOR, value: "#0000FF" },
                        { key: "background", type: ContentsTypes.COLOR, value: "" },
                    ],
                },
            ],
        },
        {
            key: "surtitleOfferTargetPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "À qui s'adresse le Pack cyber",
        },
        {
            key: "titleOfferTargetPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Une offre pensée pour protéger les petites structures sans complexité",
        },
        {
            key: "descriptionOfferTargetPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Le Pack Cyber s’adresse aux TPE, petites PME, petites collectivités, associations et petites structures publiques qui souhaitent mettre en place un premier socle de protection clair, lisible et accompagné, porté par un acteur français de confiance avancée.",
        },
        {
            key: "targetDynamic",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: [
                {
                    key: "dynamicElements",
                    type: customTypes.LIST_WRAP,
                    value: "",
                    children: [
                        {
                            key: "dynamicList",
                            type: ContentsTypes.DYNAMIC_LIST,
                            value: "",
                            children: [
                                {
                                    key: "contentType",
                                    value: customTypes.LIST_WRAP_ITEM,
                                    children: [
                                        {
                                            key: "items",
                                            type: customTypes.LIST_WRAP_ITEM,
                                            value: "",
                                            children: [
                                                {
                                                    key: "label",
                                                    type: ContentsTypes.INPUT,
                                                    value: "TPE",
                                                },
                                            ],
                                        },
                                        {
                                            key: "items",
                                            type: customTypes.LIST_WRAP_ITEM,
                                            value: "",
                                            children: [
                                                {
                                                    key: "label",
                                                    type: ContentsTypes.INPUT,
                                                    value: "Petites PME",
                                                },
                                            ],
                                        },
                                        {
                                            key: "items",
                                            type: customTypes.LIST_WRAP_ITEM,
                                            value: "",
                                            children: [
                                                {
                                                    key: "label",
                                                    type: ContentsTypes.INPUT,
                                                    value: "Petites collectivités",
                                                },
                                            ],
                                        },
                                        {
                                            key: "items",
                                            type: customTypes.LIST_WRAP_ITEM,
                                            value: "",
                                            children: [
                                                {
                                                    key: "label",
                                                    type: ContentsTypes.INPUT,
                                                    value: "Associations",
                                                },
                                            ],
                                        },
                                        {
                                            key: "items",
                                            type: customTypes.LIST_WRAP_ITEM,
                                            value: "",
                                            children: [
                                                {
                                                    key: "label",
                                                    type: ContentsTypes.INPUT,
                                                    value: "Structures publiques",
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            key: "infosBlock",
            type: customTypes.INFOS_BLOCK,
            value: "",
            children: [
                {
                    key: "title",
                    type: ContentsTypes.INPUT,
                    value: "Ce pack est adapté à vos besoins si",
                },
                {
                    key: "items",
                    type: ContentsTypes.TEXT,
                    value: "<ul><li>Vous ne disposez pas d’expertise cyber dédiée en interne</li><li>Vous recherchez une offre lisible, avec un accompagnement dans la mise en service</li><li>Vous voulez centraliser vos premières protections auprès d’un interlocuteur de confiance.</li></ul>",
                },
            ],
        },
        {
            key: "titleProtectionsPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Ce que le Pack Cyber protège",
        },
        {
            key: "subtitleProtectionsPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Le Pack Cyber réunit les protections essentielles pour sécuriser votre environnement numérique au quotidien",
        },
        {
            key: "descriptionProtectionsPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Le Pack Cyber réunit trois protections complémentaires. Ouvrez chaque protection pour comprendre le risque, la réponse Docaposte et le bénéfice pour votre organisation.",
        },
        {
            key: "dynamicProtectionsPart",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: [
                createIllustrationTabs("vertical", [
                    {
                        label: "Protection des postes de travail",
                        borderColor: "#0CFFC6",
                        sections: [
                            {
                                label: "Le risque",
                                text: "Un logiciel malveillant, une intrusion ou une activité suspecte peut compromettre un poste et se propager dans l'environnement numérique.",
                            },
                            {
                                label: "La réponse Docaposte",
                                text: "Notre protection supervisée combine détection logicielle, surveillance continue et qualification des alertes par un service spécialisé.",
                            },
                            {
                                label: "Votre bénéfice",
                                text: "Vous limitez les risques d'interruption, de propagation et de perte de données, sans recruter d'expertise cyber en interne.",
                            },
                        ],
                    },
                    {
                        label: "Patrimoine de données sécurisé",
                        borderColor: "#BF7CFF",
                        sections: [
                            {
                                label: "Le risque",
                                text: "Une erreur humaine, une panne, un sinistre ou une attaque peut rendre des documents essentiels indisponibles ou inutilisables",
                            },
                            {
                                label: "La réponse Docaposte",
                                text: "Notre sauvegarde sécurisée permet de conserver les données importantes, de les protéger et de les restaurer en cas d’incident. ",
                            },
                            {
                                label: "Votre bénéfice",
                                text: "Vos équipes adoptent de meilleurs réflexes, gagnent du temps et réduisent les risques de compromission de compte.",
                            },
                        ],
                    },
                    {
                        label: "Mots de passe centralisés et sécurisés",
                        borderColor: "#FFFF80",
                        sections: [
                            {
                                label: "Le risque",
                                text: "Des mots de passe faibles, réutilisés ou stockés dans des fichiers non sécurisés peuvent exposer les comptes et applications de l’organisation. ",
                            },
                            {
                                label: "La réponse Docaposte",
                                text: "Notre gestionnaire de mots de passe permet de générer, stocker, organiser et partager des mots de passe robustes dans un coffre-fort sécurisé. ",
                            },
                            {
                                label: "Votre bénéfice",
                                text: "Vos équipes adoptent de meilleurs réflexes, gagnent du temps et réduisent les risques de compromission de compte. ",
                            },
                        ],
                    },
                ]),
            ],
        },
        {
            key: "titleInterfacePart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Interface unifiée",
        },
        {
            key: "subtitleInterfacePart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "L'Espace client : votre centre de contrôle cyber",
        },
        {
            key: "descriptionInterfacePart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "L'espace client Docaposte centralise les informations utiles pour suivre les services activés, accéder aux ressources disponibles et faciliter les échanges avec le support.",
        },
        {
            key: "imageInterfacePart",
            type: "IMAGE_BLOCK",
            value: "",
            children: [
                {
                    key: "image",
                    type: ContentsTypes.IMAGE,
                    value: "",
                    children: [
                        {
                            key: "file",
                            type: ContentsTypes.FILE_IMAGE,
                            value: JSON.stringify({
                                id: "",
                                name: "",
                                mimeType: "image/webp",
                                publicUrl: `/api/medias/""`,
                                url: `/api/medias/""`,
                                alt: "image",
                                title: "image",
                            }),
                        },
                        { key: "alt", type: ContentsTypes.INPUT, value: "image" },
                        { key: "title", type: ContentsTypes.INPUT, value: "image" },
                        {
                            key: "position_verticale",
                            type: ContentsTypes.SELECT,
                            value: "top",
                        },
                        {
                            key: "position_horizontale",
                            type: ContentsTypes.SELECT,
                            value: "center",
                        },
                        {
                            key: "position_ajustement",
                            type: ContentsTypes.SELECT,
                            value: "cover",
                        },
                    ],
                },
                { key: "width", type: "SLIDER", value: "100" },
                { key: "mobileWidth", type: "SLIDER", value: "100" },
                { key: "justifyContent", type: "SELECT", value: "flex-start" },
            ],
        },
        {
            key: "interfaceFeaturestList",
            type: customTypes.LIST_INFOS,
            value: "",
            children: [
                {
                    key: "dynamicList",
                    type: ContentsTypes.DYNAMIC_LIST,
                    value: "",
                    children: [
                        {
                            key: "contentType",
                            value: customTypes.LIST_INFOS_ITEM,
                            children: [
                                {
                                    key: "items",
                                    type: customTypes.LIST_INFOS_ITEM,
                                    value: "",
                                    children: [
                                        {
                                            key: "label",
                                            type: ContentsTypes.INPUT,
                                            value: "Protection supervisée des postes",
                                        },
                                        {
                                            key: "description",
                                            type: ContentsTypes.INPUT,
                                            value: "Suivi en temps réel des alertes de sécurité.",
                                        },
                                    ],
                                },
                                {
                                    key: "items",
                                    type: customTypes.LIST_INFOS_ITEM,
                                    value: "",
                                    children: [
                                        {
                                            key: "label",
                                            type: ContentsTypes.INPUT,
                                            value: "Sauvegarde sécurisée",
                                        },
                                        {
                                            key: "description",
                                            type: ContentsTypes.INPUT,
                                            value: "Historique et état de vos sauvegardes critiques.",
                                        },
                                    ],
                                },
                                {
                                    key: "items",
                                    type: customTypes.LIST_INFOS_ITEM,
                                    value: "",
                                    children: [
                                        {
                                            key: "label",
                                            type: ContentsTypes.INPUT,
                                            value: "Configuration",
                                        },
                                        {
                                            key: "description",
                                            type: ContentsTypes.INPUT,
                                            value: "Déploiement rapide de vos solutions de cybersécurité.",
                                        },
                                    ],
                                },
                                {
                                    key: "items",
                                    type: customTypes.LIST_INFOS_ITEM,
                                    value: "",
                                    children: [
                                        {
                                            key: "label",
                                            type: ContentsTypes.INPUT,
                                            value: "Ressources",
                                        },
                                        {
                                            key: "description",
                                            type: ContentsTypes.INPUT,
                                            value: "Guides, bonnes pratiques et documentations techniques.",
                                        },
                                    ],
                                },
                                {
                                    key: "items",
                                    type: customTypes.LIST_INFOS_ITEM,
                                    value: "",
                                    children: [
                                        {
                                            key: "label",
                                            type: ContentsTypes.INPUT,
                                            value: "Support Docaposte basé en France",
                                        },
                                        {
                                            key: "description",
                                            type: ContentsTypes.INPUT,
                                            value: "Une assistance humaine disponible en cas de besoin.",
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            key: "titlePricePart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Un prix clair pour protéger l'essentiel",
        },
        {
            key: "descriptionPricePart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Une offre lisible, avec un budget maîtrisé dès le départ : un tarif par poste, un engagement simple et un délai de mise en service annoncé.",
        },
        {
            key: "priceDynamicPart",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: [
                {
                    key: "dynamicElements",
                    type: "BUTTON",
                    value: "",
                    children: [
                        {
                            key: "text",
                            type: ContentsTypes.INPUT,
                            value: "Demander à être accompagné",
                        },
                        { key: "color", type: "BUTTON_GROUP", value: "primary" },
                        { key: "variant", type: "BUTTON_GROUP", value: "contained" },
                        { key: "size", type: "BUTTON_GROUP", value: "large" },
                        { key: "fullWidth", type: "CHECKBOX", value: "false" },
                        {
                            key: "justifyContent",
                            type: "BUTTON_GROUP",
                            value: "flex-start",
                        },
                        {
                            key: "link",
                            type: ContentsTypes.LINK,
                            value: "",
                            children: [
                                { key: "url", type: ContentsTypes.URL, value: "" },
                                { key: "page", type: "PAGE", value: "" },
                                { key: "title", type: ContentsTypes.INPUT, value: "" },
                                { key: "external", type: "CHECKBOX", value: "false" },
                            ],
                        },
                        {
                            key: "icon",
                            type: ContentsTypes.ICON,
                            value: "",
                            children: [
                                {
                                    key: "icon",
                                    type: ContentsTypes.INPUT,
                                    value: "long-arrow-right",
                                },
                                { key: "type", type: ContentsTypes.SELECT, value: "far" },
                                { key: "color", type: ContentsTypes.COLOR, value: "#0000FF" },
                                { key: "background", type: ContentsTypes.COLOR, value: "" },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            key: "cardPrice",
            type: customTypes.CARD_PRICE,
            value: "",
            children: [
                {
                    key: "barColor",
                    type: ContentsTypes.COLOR,
                    value: "#0CFFC6",
                },
                {
                    key: "surtitle",
                    type: ContentsTypes.INPUT,
                    value: "Tarif",
                },
                { key: "title", type: ContentsTypes.INPUT, value: "15,99 €" },
                {
                    key: "titleComplement",
                    type: ContentsTypes.INPUT,
                    value: "HT / poste / mois",
                },
                {
                    key: "dynamicList",
                    type: ContentsTypes.DYNAMIC_LIST,
                    value: "",
                    children: [
                        {
                            key: "contentType",
                            value: customTypes.CARD_PRICE_ROW_ITEM,
                            children: [
                                {
                                    key: "items",
                                    type: customTypes.CARD_PRICE_ROW_ITEM,
                                    value: "",
                                    children: [
                                        {
                                            key: "label",
                                            type: ContentsTypes.INPUT,
                                            value: "Engagement",
                                        },
                                        { key: "amount", type: ContentsTypes.INPUT, value: "1 an" },
                                        { key: "complement", type: ContentsTypes.INPUT, value: "" },
                                    ],
                                },
                                {
                                    key: "items",
                                    type: customTypes.CARD_PRICE_ROW_ITEM,
                                    value: "",
                                    children: [
                                        {
                                            key: "label",
                                            type: ContentsTypes.INPUT,
                                            value: "Périmètre",
                                        },
                                        {
                                            key: "amount",
                                            type: ContentsTypes.INPUT,
                                            value: "Jusqu'à 20 postes",
                                        },
                                        { key: "complement", type: ContentsTypes.INPUT, value: "" },
                                    ],
                                },
                                {
                                    key: "items",
                                    type: customTypes.CARD_PRICE_ROW_ITEM,
                                    value: "",
                                    children: [
                                        {
                                            key: "label",
                                            type: ContentsTypes.INPUT,
                                            value: "Frais de mise en service",
                                        },
                                        {
                                            key: "amount",
                                            type: ContentsTypes.INPUT,
                                            value: "490 € HT",
                                        },
                                        {
                                            key: "complement",
                                            type: ContentsTypes.INPUT,
                                            value: "Accompagnement optionnel",
                                        },
                                    ],
                                },
                                {
                                    key: "items",
                                    type: customTypes.CARD_PRICE_ROW_ITEM,
                                    value: "",
                                    children: [
                                        {
                                            key: "label",
                                            type: ContentsTypes.INPUT,
                                            value: "Délai mise en service",
                                        },
                                        { key: "amount", type: ContentsTypes.INPUT, value: "" },
                                        {
                                            key: "complement",
                                            type: ContentsTypes.INPUT,
                                            value: "Sous 14 jours ouvrés après souscription, sous réserve de validation des informations nécessaires et de disponibilité du client.",
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            key: "labelDynamic",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: [
                {
                    key: "dynamicElements",
                    type: "GRID",
                    value: "",
                    children: [
                        {
                            key: "items",
                            type: customTypes.CARD_LABEL,
                            value: "",
                            children: [
                                {
                                    key: "title",
                                    type: ContentsTypes.INPUT,
                                    value: "Docaposte, filiale du Groupe La Poste",
                                },
                                {
                                    key: "description",
                                    type: ContentsTypes.SHORT_TEXT,
                                    value: "Un acteur français de confiance, ancré dans l’écosystème de la confiance numérique",
                                },
                                {
                                    key: "alignment",
                                    type: ContentsTypes.SELECT,
                                    value: "center",
                                },
                            ],
                        },
                        {
                            key: "items",
                            type: customTypes.CARD_LABEL,
                            value: "",
                            children: [
                                {
                                    key: "title",
                                    type: ContentsTypes.INPUT,
                                    value: "EDR partenaire reconnu ANSSI / BSI",
                                },
                                {
                                    key: "description",
                                    type: ContentsTypes.SHORT_TEXT,
                                    value: "Premier EDR qualifié en France et seul avec double certification ANSSI / BSI",
                                },
                                {
                                    key: "alignment",
                                    type: ContentsTypes.SELECT,
                                    value: "center",
                                },
                            ],
                        },
                        {
                            key: "items",
                            type: customTypes.CARD_LABEL,
                            value: "",
                            children: [
                                {
                                    key: "title",
                                    type: ContentsTypes.INPUT,
                                    value: "Souveraineté et hébergement en France",
                                },
                                {
                                    key: "description",
                                    type: ContentsTypes.SHORT_TEXT,
                                    value: "Données et services opérés dans un cadre de confiance, hébergés en France",
                                },
                                {
                                    key: "icon",
                                    type: ContentsTypes.ICON,
                                    value: "",
                                    children: [
                                        {
                                            key: "icon",
                                            type: ContentsTypes.INPUT,
                                            value: "souverainete",
                                        },
                                        {
                                            key: "type",
                                            type: ContentsTypes.SELECT,
                                            value: "custom",
                                        },
                                        {
                                            key: "color",
                                            type: ContentsTypes.COLOR,
                                            value: "#0000FF",
                                        },
                                        {
                                            key: "background",
                                            type: ContentsTypes.COLOR,
                                            value: "",
                                        },
                                    ],
                                },
                                {
                                    key: "alignment",
                                    type: ContentsTypes.SELECT,
                                    value: "center",
                                },
                            ],
                        },
                        {
                            key: "items",
                            type: customTypes.CARD_LABEL,
                            value: "",
                            children: [
                                {
                                    key: "title",
                                    type: ContentsTypes.INPUT,
                                    value: "Accompagnement Docaposte",
                                },
                                {
                                    key: "description",
                                    type: ContentsTypes.SHORT_TEXT,
                                    value: "Une relation client centralisée pour faciliter la mise en service, le suivi et le support.",
                                },
                                {
                                    key: "icon",
                                    type: ContentsTypes.ICON,
                                    value: "",
                                    children: [
                                        {
                                            key: "icon",
                                            type: ContentsTypes.INPUT,
                                            value: "relation_collaborateur",
                                        },
                                        {
                                            key: "type",
                                            type: ContentsTypes.SELECT,
                                            value: "custom",
                                        },
                                        {
                                            key: "color",
                                            type: ContentsTypes.COLOR,
                                            value: "#0000FF",
                                        },
                                        {
                                            key: "background",
                                            type: ContentsTypes.COLOR,
                                            value: "",
                                        },
                                    ],
                                },
                                {
                                    key: "alignment",
                                    type: ContentsTypes.SELECT,
                                    value: "center",
                                },
                            ],
                        },
                        { key: "size", type: "SELECT_GRID", value: "3" },
                        { key: "sizeSm", type: "SELECT_GRID", value: "6" },
                        { key: "sizeXs", type: "SELECT_GRID", value: "12" },
                        { key: "justify", type: "SELECT", value: "center" },
                        { key: "alignItems", type: "SELECT", value: "stretch" },
                        { key: "spacing", type: "SLIDER", value: "24" },
                        { key: "mobileSpacing", type: "SLIDER", value: "16" },
                    ],
                },
            ],
        },
        {
            key: "titleSetupPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Étapes de mise en place",
        },
        {
            key: "subtitleSetupPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Un parcours de mise en service clair, avec l'accompagnement de Docaposte",
        },
        {
            key: "descriptionSetupPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Dans un délai de 14 jours ouvré après la souscription, les équipes Docaposte vous accompagnent dans les premières étapes de mise en service afin de simplifier l’installation, répondre à vos questions et faciliter la prise en main.",
        },
        {
            key: "dynamicSetupPart",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: [
                createStepsItem([
                    {
                        title: "Vérification de votre besoin",
                        description: "Docaposte vous accompagne pour préciser les éléments nécessaires à la mise en service : nombre de postes à couvrir, environnement technique et informations utiles au déploiement.",
                        borderColor: "#0CFFC6",
                    },
                    {
                        title: "Validation & souscription",
                        description: "Le contrat est finalisé et les modalités de paiement sont confirmées afin de lancer la préparation de votre service.",
                        borderColor: "#BF7CFF",
                    },
                    {
                        title: "Mise en service",
                        description: "Docaposte vous guide dans la mise en service de votre Pack Cyber : création des comptes, paramétrage des outils et mise à disposition des ressources utiles.",
                        borderColor: "#FFFF80",
                    },
                    {
                        title: "Lancement de la protection",
                        description: "Votre Pack Cyber est opérationnel : protections activées, ressources pour faciliter la prise en main et accès au support Docaposte en cas de besoin.",
                        borderColor: "#0CFFC6",
                    },
                ], "#F6F6F9"),
            ],
        },
        {
            key: "titleContactPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Vous souhaitez mettre en place votre Pack Cyber ?",
        },
        {
            key: "descriptionContactPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Un expert Docaposte vous accompagne pour confirmer votre besoin, préciser le périmètre à protéger et organiser la mise en service.",
        },
        {
            key: "dynamicContactPart",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: [createButton("Être rappelé par un expert", "contact")],
        },
        {
            key: "titleFurtherPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Aller plus loin",
        },
        {
            key: "subtitleFurtherPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Poursuivez votre parcours selon votre besoin",
        },
        {
            key: "dynamicFurtherPart",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: [
                {
                    key: "dynamicElements",
                    type: "GRID",
                    value: "",
                    children: [
                        createPricingCardItem("default", "M", "#BF7CFF", "PME, collectivités moyenne", "Explorer les modules outils", "Pour compléter votre protection avec des modules adaptés à vos risques prioritaires.", "", "", "", "", "", "", "/Modules-outils", "Découvrir", "long-arrow-right"),
                        createPricingCardItem("default", "M", "#FFFF80", "ETI, grande collectivités, organisation mature", "Découvrir les prestations expertes", "Pour compléter votre protection avec un accompagnement expert sur mesure.", "", "", "", "", "", "", "/prestation-expertes", "Découvrir", "long-arrow-right"),
                        createPricingCardItem("highlighted", "M", "#0000FF", "", "Revenir à l'accueil de l'offre Cyber", "Pour retrouver une vue d'ensemble de nos solutions cyber.", "", "", "", "", "", "", "/", "Revenir", "long-arrow-right"),
                        { key: "size", type: "SELECT_GRID", value: "4" },
                        { key: "sizeSm", type: "SELECT_GRID", value: "12" },
                        { key: "sizeXs", type: "SELECT_GRID", value: "12" },
                        { key: "justify", type: "SELECT", value: "center" },
                        { key: "alignItems", type: "SELECT", value: "stretch" },
                        { key: "spacing", type: "SLIDER", value: "48" },
                        { key: "mobileSpacing", type: "SLIDER", value: "16" },
                    ],
                },
            ],
        },
    ],
};
